export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline":
      "Infraestructura transparente y sin fronteras para la generosidad.",
    "common.skipToMainContent": "Saltar al contenido principal",
    "common.cancel": "Cancelar",
    "common.edit": "Editar",
    "common.delete": "Eliminar",
    "common.creating": "Creando...",
    "common.unknown": "Desconocido",
    "common.notAvailable": "N/D",

    // Navigation
    "nav.browse": "Explorar Organizaciones",
    "nav.opportunities": "Oportunidades de Voluntariado",
    "nav.contributions": "Seguimiento de Contribuciones",
    "nav.governance": "Gobernanza",
    "nav.dashboard": "Panel de Control",
    "nav.about": "Acerca de",
    "nav.docs": "Documentación",
    "nav.legal": "Legal",
    "nav.launchApp": "Iniciar Aplicación",

    // FAQ page (GIV-988)
    "faq.title": "Preguntas Frecuentes",
    "faq.subtitle":
      "Todo lo que necesitas saber sobre donar, ser voluntario y la transparencia blockchain.",

    // Settings
    "settings.title": "Configuración",
    "settings.language": "Idioma",
    "settings.currency": "Moneda",

    // Auth
    "auth.login": "Iniciar Sesión",
    "auth.register": "Crear Cuenta",
    "auth.logout": "Cerrar Sesión",
    "auth.forgotPassword": "¿Olvidó su Contraseña?",

    // Dashboard
    "dashboard.title": "Panel de Control",
    "dashboard.subtitle":
      "Seguimiento de donaciones y contribuciones voluntarias",
    "dashboard.totalDonations": "Donaciones Totales",
    "dashboard.volunteerHours": "Horas de Voluntariado",
    "dashboard.skillsEndorsed": "Habilidades Respaldadas",
    "dashboard.contributions": "Contribuciones",
    "dashboard.yourTotalDonated": "Total Donado",
    "dashboard.yourVolunteerHours": "Sus Horas de Voluntariado",
    "dashboard.yourSkillsEndorsed": "Sus Habilidades Respaldadas",
    "dashboard.impactGrowth": "Crecimiento del Impacto",
    "dashboard.charitiesSupported": "Organizaciones Apoyadas",

    // Charity
    "charity.dashboard": "Panel de la Organización",
    "charity.subtitle": "Administre sus donaciones y programas de voluntariado",
    "charity.activeVolunteers": "Voluntarios Activos",
    "charity.transactions": "Transacciones",
    "charity.volunteers": "Horas de Voluntariado",
    "charity.applications": "Solicitudes",
    "charity.totalReceived": "Total Recibido",
    "charity.equityPoolValue": "Valor del Fondo de Equidad",
    "charity.availableBalance": "Saldo Disponible",

    // Contributions
    "contributions.date": "Fecha",
    "contributions.type": "Tipo",
    "contributions.organization": "Organización",
    "contributions.details": "Detalles",
    "contributions.status": "Estado",
    "contributions.verification": "Verificación",
    "contributions.export": "Exportar CSV",

    // Volunteer
    "volunteer.opportunities": "Oportunidades de Voluntariado",
    "volunteer.searchOpportunities": "Buscar oportunidades...",
    "volunteer.selectSkill": "Seleccionar habilidad",
    "volunteer.selectType": "Seleccionar tipo",
    "volunteer.selectLanguage": "Seleccionar idioma",
    "volunteer.allSkills": "Todas las Habilidades",
    "volunteer.allTypes": "Todos los Tipos",
    "volunteer.allLanguages": "Todos los Idiomas",
    "volunteer.applyNow": "Postularse Ahora",
    "volunteer.noOpportunitiesFound":
      "No se encontraron oportunidades que coincidan con sus criterios.",
    "volunteer.verify": "Verificar Horas",
    "volunteer.verifying": "Verificando...",
    "volunteer.reject": "Rechazar",
    "volunteer.accept": "Aceptar",
    "volunteer.processing": "Procesando...",
    "volunteer.hours": "horas en",
    "volunteer.description": "Descripción",
    "volunteer.appliedFor": "Postuló para",
    "volunteer.verificationComplete": "Verificación Completada",
    "volunteer.hoursVerified":
      "Las horas de voluntariado han sido verificadas y registradas en la blockchain.",
    "volunteer.verificationHash": "Hash de Verificación",
    "volunteer.applicationAccepted": "Solicitud Aceptada",
    "volunteer.applicationRecorded":
      "La solicitud de voluntariado ha sido aceptada y registrada en la blockchain.",
    "volunteer.acceptanceHash": "Hash de Aceptación",
    "volunteer.pendingHours": "Horas de Voluntariado Pendientes",
    "volunteer.noPendingHours":
      "No hay horas de voluntariado pendientes por verificar.",
    "volunteer.pendingApplications": "Solicitudes Pendientes",
    "volunteer.noPendingApplications":
      "No hay solicitudes pendientes por revisar.",
    "volunteer.createOpportunity": "Crear Oportunidad de Voluntariado",
    "volunteer.createNew": "Crear Nueva",
    "volunteer.noOpportunitiesYet":
      'Aún no se han creado oportunidades. Haga clic en "Crear Nueva" para comenzar.',
    "volunteer.opportunityTitle": "Título de la Oportunidad",
    "volunteer.skills": "Habilidades (separadas por comas)",
    "volunteer.commitment": "Compromiso",
    "volunteer.location": "Ubicación",
    "volunteer.type": "Tipo",
    "volunteer.workLanguage": "Idioma de Trabajo",
    "volunteer.status": "Estado",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "Única vez",
    "volunteer.commitment.shortTerm": "Corto plazo",
    "volunteer.commitment.longTerm": "Largo plazo",

    // Volunteer types
    "volunteer.type.remote": "Remoto",
    "volunteer.type.onsite": "Presencial",
    "volunteer.type.hybrid": "Híbrido",
    "volunteer.type.onSite": "Presencial",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "Filtro de tipo de trabajo",
    "volunteer.searchLocation": "Ciudad o región...",
    "volunteer.searchLocationAria": "Buscar ubicación",
    "volunteer.filter.skill": "Habilidad: {{value}}",
    "volunteer.filter.type": "Tipo: {{value}}",
    "volunteer.filter.language": "Idioma: {{value}}",
    "volunteer.filter.location": "Ubicación: {{value}}",
    "volunteer.loadingOpportunities": "Cargando oportunidades...",
    "volunteer.loadOpportunitiesError": "No pudimos cargar las oportunidades de voluntariado. Inténtalo de nuevo más tarde.",
    "volunteer.viewDetails": "Ver detalles",
    "volunteer.backToOpportunities": "Volver a las oportunidades",
    "volunteer.detail.about": "Acerca de esta oportunidad",
    "volunteer.detail.skills": "Habilidades necesarias",
    "volunteer.detail.commitment": "Compromiso de tiempo",
    "volunteer.detail.location": "Ubicación",
    "volunteer.detail.language": "Idioma",
    "volunteer.detail.hostedBy": "Organizado por",
    "volunteer.detail.ongoing": "Continuo",
    "volunteer.detail.applicationsClosed": "Solicitudes cerradas",
    "volunteer.detail.notFoundTitle": "Oportunidad no encontrada",
    "volunteer.detail.notFoundMessage": "Es posible que esta oportunidad se haya cubierto o eliminado.",
    "volunteer.field.requirements": "Requisitos",
    "volunteer.field.benefits": "Beneficios",
    "volunteer.field.schedule": "Horario",
    "volunteer.field.schedulePlaceholder": "p. ej., martes de 18 a 20 h, fines de semana flexibles",
    "volunteer.field.startDate": "Fecha de inicio",
    "volunteer.field.endDate": "Fecha de finalización",
    "volunteer.field.endDateHelp": "Deja en blanco si es continuo",
    "volunteer.field.applicationDeadline": "Fecha límite de solicitud",
    "volunteer.field.volunteersNeeded": "Voluntarios necesarios",
    "volunteer.field.minimumAge": "Edad mínima",
    "volunteer.field.backgroundCheckRequired": "Se requiere verificación de antecedentes",
    "volunteer.field.trainingProvided": "Capacitación incluida",
    "volunteer.field.onePerLine": "uno por línea",
    "volunteer.validation.volunteersNeeded": "Introduce un número de 1 o más",
    "volunteer.validation.minimumAge": "Introduce una edad entre 0 y 120",
    "volunteer.validation.endDate": "La fecha de finalización debe ser igual o posterior a la de inicio",
    "volunteer.signInToApply":
      "Inicie sesión para postularse a oportunidades de voluntariado",
    "volunteer.applicationSuccess": "¡Solicitud enviada exitosamente!",
    "volunteer.removeFilter": "Eliminar filtro {{filter}}",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "El título es obligatorio",
    "volunteer.validation.descriptionRequired": "La descripción es obligatoria",
    "volunteer.validation.skillsRequired": "Se requiere al menos una habilidad",
    "volunteer.validation.locationRequired": "La ubicación es obligatoria",
    "volunteer.profileNotFound": "Perfil de usuario no encontrado",
    "volunteer.correctErrors": "Por favor corrija los errores de validación",
    "volunteer.createFailed": "Error al crear la oportunidad",
    "volunteer.descriptionPlaceholder":
      "Describa la oportunidad de voluntariado en detalle...",
    "volunteer.skillsPlaceholder":
      "ej., Desarrollo Web, Gestión de Proyectos, Traducción",
    "volunteer.locationPlaceholder": "ej., Remoto, Nueva York, Berlín",
    "volunteer.headerImage": "Imagen de Encabezado",
    "volunteer.headerImageHelp":
      "Suba una imagen para mostrar en la parte superior de su anuncio",
    "volunteer.limitReached": "Límite de Oportunidades Alcanzado",
    "volunteer.limitReachedMessage":
      "Ha alcanzado el máximo de {{max}} oportunidades de voluntariado activas. Cierre o complete una oportunidad existente antes de crear una nueva.",
    "volunteer.opportunityCount":
      "Tiene {{count}} de {{max}} oportunidades activas.",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "Verificación de Horas",
    "volunteer.hoursVerificationDescription":
      "Revise y verifique las horas de voluntariado enviadas",
    "volunteer.formalHours": "Horas Registradas",
    "volunteer.selfReported": "Auto-reportadas",
    "volunteer.loggedHours": "Horas de Voluntariado Registradas",
    "volunteer.loggedHoursDescription":
      "Horas registradas por voluntarios a través de sus oportunidades",
    "volunteer.allCaughtUp": "¡Todo al día!",
    "volunteer.noPendingLoggedHours":
      "No hay horas registradas pendientes por verificar.",
    "volunteer.selfReportedHours": "Horas Auto-reportadas",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "Aún no hay oportunidades",
    "volunteer.activeCount": "{{count}} de {{max}} oportunidades activas",
    "volunteer.moreSkills": "+{{count}} más",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "No hay solicitudes pendientes",
    "volunteer.unknownOpportunity": "Oportunidad Desconocida",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "Verificar Contribución de Voluntariado",
    "volunteer.hashPlaceholder": "Ingrese el hash de verificación",
    "volunteer.searching": "Buscando...",
    "volunteer.verifyHash": "Verificar Hash",
    "volunteer.verificationNotFound": "Verificación No Encontrada",
    "volunteer.verificationNotFoundMessage":
      "El hash proporcionado no se encontró en nuestros registros. Verifique el hash e intente nuevamente.",
    "volunteer.unknownOrganization": "Organización Desconocida",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification":
      "Verificación de Contribución Voluntaria",
    "volunteer.volunteerLabel": "Voluntario",
    "volunteer.opportunityLabel": "Oportunidad",
    "volunteer.organizationLabel": "Organización",
    "volunteer.acceptedOn": "Aceptado el",
    "volunteer.verifiedOn": "Verificado el",
    "volunteer.verificationHashes": "Hashes de Verificación",
    "volunteer.blockchainReference": "Referencia en Blockchain",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "Verificando contribución\u2026",
    "volunteer.noHashProvided": "No se proporcionó un hash de verificación.",
    "volunteer.verificationSuccessful": "Verificación Exitosa",
    "volunteer.contributionVerifiedBlockchain":
      "Esta contribución voluntaria ha sido verificada y registrada en la blockchain.",
    "volunteer.verificationFailed": "Verificación Fallida",
    "volunteer.hashNotFound":
      "El hash de verificación {{hash}} no se encontró o no es válido.",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "Horas de Voluntariado",
    "volunteer.aboutSelfReported": "Acerca de las Horas Auto-reportadas",
    "volunteer.selfReportedInfo":
      "Solo las horas validadas por organizaciones verificadas cuentan para los Rankings de Impacto Global. Las horas para organizaciones fuera de nuestra plataforma pueden registrarse pero serán marcadas como \u201cNo Validadas\u201d hasta que se reciba la validación.",
    "volunteer.logHoursButton": "Registrar Horas",
    "volunteer.logVolunteerHours": "Registrar Horas de Voluntariado",
    "volunteer.editRecord": "Editar Registro",
    "volunteer.recordDetails": "Detalles del Registro",
    "volunteer.backToList": "Volver a la Lista",
    "volunteer.deleteRecord": "¿Eliminar Registro?",
    "volunteer.deleteConfirmation":
      "¿Está seguro de que desea eliminar este registro de horas de voluntariado? Esta acción no se puede deshacer.",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "Tipo de Actividad",
    "volunteer.organization": "Organización",
    "volunteer.searchRegistry": "Buscar en el Registro",
    "volunteer.searchRegistryPlaceholder":
      "Buscar en el registro de organizaciones por nombre o ID fiscal…",
    "volunteer.registryTaxId": "ID fiscal {{value}}",
    "volunteer.notListed": "No Listada",
    "volunteer.organizationName": "Nombre de la Organización",
    "volunteer.enterOrgName": "Ingrese el nombre de la organización",
    "volunteer.contactEmail": "Correo de Contacto",
    "volunteer.contactEmailOptional": "(opcional)",
    "volunteer.onboardHelp":
      "Podemos comunicarnos para ayudar a incorporar esta organización",
    "volunteer.submittedForValidation":
      "Este registro será enviado para validación",
    "volunteer.submittedForValidationTo":
      "Este registro será enviado para validación a {{org}}",
    "volunteer.validationExpired":
      "El período de validación ha expirado para esta fecha",
    "volunteer.savedAsUnvalidated":
      "Este registro se guardará como no validado",
    "volunteer.describeActivities": "Describa las actividades que realizó...",
    "volunteer.moreCharsNeeded": "{{count}} caracteres más necesarios",
    "volunteer.updating": "Actualizando...",
    "volunteer.logging": "Registrando...",
    "volunteer.updateHours": "Actualizar Horas",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "Estado",
    "volunteer.activityTypeFilter": "Tipo de Actividad",
    "volunteer.filterFrom": "Desde",
    "volunteer.filterTo": "Hasta",
    "volunteer.clearFilters": "Limpiar filtros",
    "volunteer.allStatuses": "Todos",
    "volunteer.allActivityTypes": "Todos los Tipos",
    "volunteer.noMatchingRecords": "No se encontraron registros",
    "volunteer.noHoursLogged": "Aún no se han registrado horas de voluntariado",
    "volunteer.adjustFilters":
      "Intente ajustar sus filtros para encontrar registros.",
    "volunteer.startLogging":
      "Comience registrando sus primeras horas de voluntariado.",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "Horas Validadas",
    "volunteer.pendingValidation": "Validación Pendiente",
    "volunteer.unvalidatedHours": "Horas No Validadas",
    "volunteer.rejectedLabel": "Rechazadas",
    "volunteer.hoursUnit": "hrs",
    "volunteer.recordSingular": "registro",
    "volunteer.recordPlural": "registros",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "Solicitud de Oportunidad de Voluntariado",
    "volunteer.applicationSubtitle":
      "Ayude a crear un impacto sostenible a través de contribuciones verificadas",
    "volunteer.progress.info": "Info",
    "volunteer.progress.skills": "Habilidades",
    "volunteer.progress.consent": "Consentimiento",
    "volunteer.fieldValid": "Se ve bien",
    "volunteer.draftSaved": "Borrador guardado",
    "volunteer.personalInfo": "Información Personal",
    "volunteer.firstName": "Nombre",
    "volunteer.lastName": "Apellido",
    "volunteer.emailAddress": "Correo Electrónico",
    "volunteer.phoneNumber": "Número de Teléfono",
    "volunteer.locationCity": "Ubicación/Ciudad",
    "volunteer.locationCityPlaceholder": "ej., Ciudad de México, MX",
    "volunteer.timeZone": "Zona Horaria",
    "volunteer.selectTimeZone": "Seleccionar Zona Horaria",
    "volunteer.ageRange": "Rango de Edad",
    "volunteer.selectAgeRange": "Seleccionar Rango de Edad",
    "volunteer.skillsAndInterests": "Habilidades e Intereses",
    "volunteer.skillsLabel": "Habilidades y Áreas de Interés",
    "volunteer.skillPlaceholderFull":
      "Comience a escribir sus habilidades (ej., Programación en Python, Oratoria, Redacción de subvenciones)",
    "volunteer.skillPlaceholderShort":
      "Escriba una habilidad y presione Enter...",
    "volunteer.commitmentLevel": "Nivel de Compromiso",
    "volunteer.commitmentOneTimeDesc":
      "Proyecto único o tareas de corta duración",
    "volunteer.commitmentShortTermDesc": "Unas semanas a algunos meses",
    "volunteer.commitmentLongTermDesc":
      "Compromiso continuo de varios meses o más",
    "volunteer.experienceLabel": "Cuéntenos sobre su experiencia relevante",
    "volunteer.experiencePlaceholder":
      "Describa su experiencia, habilidades y qué le motiva a ser voluntario con Give Protocol...",
    "volunteer.consentTitle": "Consentimiento y Acuerdo",
    "volunteer.consentHeader": "Consentimiento de Solicitud de Voluntariado",
    "volunteer.submitting": "Enviando...",
    "volunteer.submitApplication": "Enviar Solicitud de Voluntariado",
    "volunteer.disclaimerText":
      "Al enviar esta solicitud, usted reconoce que ha leído y comprendido la política de privacidad y las directrices para voluntarios de Give Protocol. Sus datos serán procesados de acuerdo con las regulaciones de protección de datos aplicables.",
    "volunteer.validation.firstNameInvalid": "Ingrese un nombre válido",
    "volunteer.validation.lastNameInvalid": "Ingrese un apellido válido",
    "volunteer.validation.emailInvalid": "Ingrese un correo electrónico válido",
    "volunteer.validation.phoneInvalid": "Ingrese un número de teléfono válido",
    "volunteer.validation.experienceRequired":
      "Describa su experiencia relevante",
    "volunteer.validation.addSkill": "Agregue al menos una habilidad",
    "volunteer.validation.ageRangeRequired": "Seleccione su rango de edad",
    "volunteer.validation.consentRequired":
      "Debe aceptar todos los elementos de consentimiento requeridos",
    "volunteer.signInToSubmit": "Inicie sesión para enviar una solicitud",
    "volunteer.submitFailed":
      "Error al enviar la solicitud. Intente nuevamente.",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "Postularse para: {{title}}",
    "volunteer.fullName": "Nombre Completo *",
    "volunteer.phoneRequired": "Número de Teléfono *",
    "volunteer.emailRequired": "Correo Electrónico *",
    "volunteer.dateOfBirth": "Fecha de Nacimiento",
    "volunteer.availabilityTitle": "Disponibilidad",
    "volunteer.preferredDays": "Días Preferidos",
    "volunteer.preferredTimes": "Horarios Preferidos",
    "volunteer.commitmentLevelLabel": "Nivel de Compromiso",
    "volunteer.skillsAndExperience": "Habilidades y Experiencia",
    "volunteer.relevantExperience": "Experiencia Relevante *",
    "volunteer.certifications": "Certificaciones (separadas por comas)",
    "volunteer.interestsAndPreferences": "Intereses y Preferencias",
    "volunteer.areasOfInterest": "Áreas de Interés (separadas por comas)",
    "volunteer.referencesTitle": "Referencias",
    "volunteer.referenceName": "Nombre de Referencia {{index}}",
    "volunteer.referenceContact": "Contacto de Referencia {{index}}",
    "volunteer.workSamplesTitle": "Muestras de Trabajo",
    "volunteer.workSamplesLabel":
      "Enlaces a Muestras de Trabajo (separados por comas)",
    "volunteer.submitApplicationShort": "Enviar Solicitud",
    "volunteer.validation.nameInvalid":
      "Ingrese un nombre válido (2-100 caracteres)",
    "volunteer.validation.provideExperience":
      "Proporcione información sobre su experiencia",
    "volunteer.validation.selectDay": "Seleccione al menos un día",
    "volunteer.validation.selectTime": "Seleccione al menos un horario",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "Entiendo que:",
    "volunteer.processingAckTitle": "RECONOCIMIENTO DE PROCESAMIENTO",
    "volunteer.processingAckDesc":
      "Revise y confirme lo siguiente antes de continuar:",
    "volunteer.essentialProcessingTitle":
      "Procesamiento de Solicitud (Confirmación requerida):",
    "volunteer.acknowledgmentTitle": "RECONOCIMIENTO",
    "volunteer.ageConfirmationTitle": "Confirmación de Edad:",
    "volunteer.privacyNoticeTitle": "Aviso de Privacidad:",
    "volunteer.doNotAccept": "No Aceptar",
    "volunteer.acceptAndContinue": "Aceptar y Continuar",
    "volunteer.validation.essentialRequired":
      "Debe confirmar el reconocimiento de procesamiento de solicitud para continuar",
    "volunteer.validation.agePrivacyRequired":
      "Debe confirmar su edad y que ha leído el Aviso de Privacidad",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "Confirmo que tengo 16 años de edad o más.",
    "ageGate.negative":
      "Give Protocol está disponible para usuarios que tengan 16 años de edad o más. Si tiene menos de 16 años, no podemos procesar su solicitud en este momento.",

    // Languages
    "language.english": "Inglés",
    "language.spanish": "Español",
    "language.german": "Alemán",
    "language.french": "Francés",
    "language.japanese": "Japonés",
    "language.chinese_simplified": "Chino (Simplificado)",
    "language.chinese_traditional": "Chino (Tradicional)",
    "language.thai": "Tailandés",
    "language.vietnamese": "Vietnamita",
    "language.korean": "Coreano",
    "language.arabic": "Árabe",
    "language.hindi": "Hindi",
    "language.multiple": "Varios Idiomas",

    // Contribution types
    "contribution.type.donation": "Donación",
    "contribution.type.volunteerapplication": "Solicitud de Voluntariado",
    "contribution.type.volunteerhours": "Horas de Voluntariado",
    "contribution.type.volunteeracceptance": "Aceptación de Voluntariado",
    "contribution.type.volunteerverification": "Verificación de Voluntariado",

    // Donor/Volunteer
    "donor.volunteer": "Donante/Voluntario",
    "donor.anonymous": "Anónimo",
    "volunteer.unknown": "Voluntario Desconocido",

    // Statuses
    "status.completed": "Completado",
    "status.pending": "Pendiente",
    "status.failed": "Fallido",

    // Blockchain
    "blockchain.block": "Bloque",

    // Filter
    "filter.allYears": "Todos los Años",
    "filter.allTypes": "Todos los Tipos",
    "filter.donations": "Donaciones",
    "filter.volunteerApplications": "Solicitudes de Voluntariado",
    "filter.volunteerHours": "Horas de Voluntariado",
    "filter.fiatDonations": "Donaciones Fiat",

    // Export
    "export.title": "Exportar Datos de Contribuciones",
    "export.filename": "Nombre de Archivo",
    "export.dateRange": "Rango de Fechas",
    "export.includePersonal": "Incluir direcciones de billetera",
    "export.willInclude": "La exportación incluirá:",
    "export.walletAddresses":
      "Direcciones de billetera (remitente y destinatario)",
    "export.volunteerDetails":
      "Detalles de contribución voluntaria (cuando aplique)",
    "export.verificationHashes": "Hashes de verificación (cuando aplique)",
    "export.cancel": "Cancelar",
    "export.download": "Exportar CSV",

    // Skills
    "skills.endorsements": "Habilidades y Avales",

    // Home
    "home.subtitle": "Conectando recursos con las causas que más los necesitan",
    "home.startDonating": "Comenzar a Donar",

    // Modal - shared
    "modal.close": "Cerrar modal",
    "modal.closeAriaLabel": "Cerrar",

    // Modal - wallet connection
    "modal.wallet.title": "Conectar su Billetera",
    "modal.wallet.description":
      "Conecte una billetera para desbloquear todas las funciones de Give Protocol",
    "modal.wallet.benefit1":
      "Rastree sus donaciones de manera transparente en la blockchain",
    "modal.wallet.benefit2":
      "Reciba tokens GIVE como recompensa por sus contribuciones",
    "modal.wallet.benefit3":
      "Participe en decisiones de gobernanza del protocolo",
    "modal.wallet.connecting": "Conectando...",
    "modal.wallet.clickToConnect": "Clic para conectar",
    "modal.wallet.noExtension": "No se detectó extensión de billetera.",
    "modal.wallet.installMetaMask": "Instale MetaMask para comenzar",
    "modal.wallet.skip": "Omitir por ahora",
    "modal.wallet.footerNote":
      "Puede conectar su billetera en cualquier momento desde la barra de navegación",
    "modal.wallet.failedConnect": "Error al conectar la billetera",

    // Modal - wallet link
    "modal.walletLink.title": "Vincular su Billetera",
    "modal.walletLink.description":
      "Vincule una billetera a su cuenta para donaciones on-chain, recompensas de tokens y gobernanza",
    "modal.walletLink.benefit1":
      "Done criptomonedas directamente a organizaciones verificadas on-chain",
    "modal.walletLink.benefit2Pre": "Desarrolle",
    "modal.walletLink.benefit2Post": "credenciales por sus contribuciones",
    "modal.walletLink.benefit3":
      "Inicie sesión con correo o billetera \u2014 misma cuenta",
    "modal.walletLink.buttonLinking": "Vinculando\u2026",
    "modal.walletLink.buttonLink": "Vincular Billetera",
    "modal.walletLink.buttonConnectFirst": "Conectar Billetera Primero",
    "modal.walletLink.footerNote":
      "Puede vincular su billetera en cualquier momento desde Configuración",
    "modal.walletLink.failedLink": "Error al vincular la billetera",

    // Modal - chain selection
    "modal.chain.title": "Bienvenido a Give Protocol",
    "modal.chain.subtitle": "Elija su red preferida para comenzar",
    "modal.chain.footerNote":
      "Puede cambiar de red en cualquier momento desde el menú",
    "modal.chain.connecting": "Conectando...",
    "modal.chain.continue": "Continuar",
    "modal.chain.failedSelect": "Error al seleccionar la red",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "Seleccionar Red",
    "modal.network.nextStep": "Siguiente Paso: Conectar Billetera",
    "modal.network.learnMore": "Más información sobre la selección de red",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "Conectar Billetera",
    "modal.connect.backAria": "Volver a selección de red",
    "modal.connect.noWallets":
      "No hay billeteras disponibles para cadenas {{chainType}}.",
    "modal.connect.tryDifferentChain":
      "Intente seleccionar un tipo de cadena diferente.",
    "modal.connect.viewOtherWallets": "Ver otras billeteras compatibles",
    "modal.connect.termsAgreement": "Al conectar, acepta nuestros",
    "modal.connect.termsLink": "Términos de Servicio",
    "modal.connect.termsPrivacyConnector": "y",
    "modal.connect.privacyLink": "Política de Privacidad",
    "modal.connect.chainTypeAria": "Tipo de cadena",
    "modal.connect.failedConnect": "Error en la conexión",

    // Modal - donation
    "modal.donation.successTitle": "¡Gracias!",
    "modal.donation.donationProcessedOneTime":
      "Su donación de {{amount}} a {{charityName}} ha sido procesada.",
    "modal.donation.donationProcessedRecurring":
      "Su donación mensual de {{amount}} a {{charityName}} ha sido procesada.",
    "modal.donation.recurringNote":
      "Se le cobrará mensualmente hasta que cancele.",
    "modal.donation.receiptNote":
      "Se ha enviado un recibo a su correo electrónico.",
    "modal.donation.done": "Listo",
    "modal.donation.errorTitle": "Algo Salió Mal",
    "modal.donation.errorDefault":
      "Ocurrió un error inesperado. Intente nuevamente.",
    "modal.donation.tryAgain": "Intentar de Nuevo",
    "modal.donation.close": "Cerrar",
    "modal.donation.amountLabel": "Monto de Donación",
    "modal.donation.perMonth": "por mes",
    "modal.donation.monthly": "Mensual",
    "modal.donation.oneTime": "Única Vez",
    "modal.donation.loadingPaymentForm": "Cargando formulario de pago...",
    "modal.donation.supportMonthly": "Apoyar a {{charityName}} Mensualmente",
    "modal.donation.donateToCharity": "Donar a {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title":
      "Programar Donaciones Mensuales a {{charityName}}",

    // Modal - withdrawal
    "modal.withdrawal.title": "Solicitar Retiro",

    // Modal - validation response
    "modal.validation.rejectTitle": "Rechazar Solicitud de Validación",
    "modal.validation.reviewTitle": "Revisar Solicitud de Validación",
    "modal.validation.volunteer": "Voluntario",
    "modal.validation.activityDetails": "Detalles de la Actividad",
    "modal.validation.date": "Fecha",
    "modal.validation.hour": "hora",
    "modal.validation.hours": "horas",
    "modal.validation.activityType": "Tipo de Actividad",
    "modal.validation.location": "Ubicación",
    "modal.validation.description": "Descripción",
    "modal.validation.submitted": "Enviado:",
    "modal.validation.daysRemaining": "({{count}} días restantes para validar)",
    "modal.validation.appealNote":
      "Esta es una apelación/reenvío de una solicitud previamente rechazada",
    "modal.validation.rejectPrompt":
      "Seleccione una razón para rechazar esta solicitud de validación. Se notificará al voluntario.",
    "modal.validation.reject": "Rechazar",
    "modal.validation.approve": "Aprobar",
    "modal.validation.processing": "Procesando...",
    "modal.validation.back": "Volver",
    "modal.validation.confirmRejection": "Confirmar Rechazo",
    "modal.validation.selectReasonError": "Seleccione una razón de rechazo",

    // Toast
    "toast.dismiss": "Descartar notificación",

    // Error boundary
    "error.somethingWrong": "Algo salió mal",
    "error.unexpectedError": "Ocurrió un error inesperado",
    "error.tryAgain": "Intentar de Nuevo",
    "error.tooManyAttempts": "Demasiados intentos",
    "error.goHome": "Ir a la Página Principal",
    "error.details": "Detalles del Error",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "Razón de Rechazo",
    "validation.rejection.reasonPlaceholder": "Seleccione una razón...",
    "validation.rejection.notesLabel": "Notas Adicionales",
    "validation.rejection.optional": "(opcional)",
    "validation.rejection.notesPlaceholder":
      "Proporcione contexto adicional para el rechazo...",

    // Validation - batch actions
    "validation.batch.deselectAll": "Deseleccionar todo",
    "validation.batch.selectAll": "Seleccionar todo",
    "validation.batch.selected": "{{selected}} de {{total}} seleccionados",
    "validation.batch.clear": "Limpiar",
    "validation.batch.reject": "Rechazar ({{count}})",
    "validation.batch.approve": "Aprobar ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "Panel de Administración",
    "dashboard.adminNote":
      "Utilice el panel de administración para gestionar la plataforma.",
    "dashboard.adminButton": "Ir al Panel de Administración",
    "dashboard.logVolunteerHours": "Registrar Horas de Voluntariado",
    "dashboard.hideVolunteerHours": "Ocultar Horas de Voluntariado",
    "dashboard.viewMonthlyDonations": "Ver Donaciones Mensuales",
    "dashboard.hideMonthlyDonations": "Ocultar Donaciones Mensuales",
    "dashboard.walletSettings": "Configuración de Billetera",
    "dashboard.overview": "Resumen",
    "dashboard.lastUpdated": "Última actualización",
    "dashboard.refreshData": "Actualizar datos",
    "dashboard.searchPlaceholder": "Buscar proyectos, voluntarios (Cmd+K)",
    "dashboard.search": "Buscar",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "Administre su cuenta y preferencias",
    "settings.account": "Cuenta",
    "settings.email": "Correo Electrónico",
    "settings.displayName": "Nombre para Mostrar",
    "settings.authMethod": "Método de Autenticación",
    "settings.role": "Rol",

    // Common additional (GIV-254)
    "common.refresh": "Actualizar",
    "common.all": "Todo",
    "common.loading": "Cargando...",
    "common.close": "Cerrar",
    "common.back": "Volver",

    // Cause (GIV-254)
    "cause.createCause": "Crear Causa",

    // Contribution Tracker (GIV-254)
    "tracker.title": "Rankings de Impacto Global",
    "tracker.subtitle":
      "Rastree y celebre el impacto colectivo de nuestra comunidad",
    "tracker.searchPlaceholder": "Buscar contribuyentes...",
    "tracker.exportCSV": "Exportar CSV",
    "tracker.exportPDF": "Exportar PDF",
    "tracker.hideContributions": "Ocultar mis contribuciones de los rankings",
    "tracker.yourAlias": "Su alias:",
    "tracker.changeAlias": "Cambiar",
    "tracker.setWalletAlias": "Establecer Alias de Billetera",
    "tracker.aliasTitle": "Establecer Alias de Billetera",
    "tracker.aliasDescription":
      "Su alias se mostrará en el rastreador de contribuciones en lugar de su dirección de billetera.",
    "tracker.aliasLabel": "Alias",
    "tracker.aliasPlaceholder": "Ingrese su alias preferido",
    "tracker.saveAlias": "Guardar Alias",
    "tracker.donationRankings": "Rankings de Donaciones",
    "tracker.volunteerRankings": "Rankings de Voluntariado",
    "tracker.exportComplete": "Exportación Completa",
    "tracker.exportDonationCSV": "Tabla de donaciones exportada como CSV",
    "tracker.exportVolunteerCSV": "Tabla de voluntariado exportada como CSV",
    "tracker.exportPDFSuccess": "Tabla exportada como PDF",
    "tracker.exportFailed": "Error en la Exportación",
    "tracker.exportNoData": "No hay datos disponibles para exportar",
    "tracker.exportError": "Ocurrió un error al exportar los datos",
    "tracker.walletNotConnected": "Billetera no conectada",
    "tracker.connectWalletForAlias":
      "Conecte su billetera para establecer un alias",
    "tracker.invalidAlias": "Alias no válido",
    "tracker.enterValidAlias": "Ingrese un alias válido",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "¿Eliminar {{type}}?",
    "charity.portal.deleteDescription":
      "Esta acción no se puede deshacer. El/la {{type}} será eliminado/a permanentemente.",
    "charity.portal.walletNotConfigured": "Billetera receptora no configurada.",
    "charity.portal.walletDonationNote":
      "Conecte una billetera para recibir donaciones on-chain.",
    "charity.portal.setupWallet": "Configurar Billetera",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "Lista de incorporación",
    "charity.onboarding.title": "Primeros pasos",
    "charity.onboarding.progress":
      "{{completed}} de {{total}} pasos completados",
    "charity.onboarding.optional": "Opcional",
    "charity.onboarding.allComplete":
      "¡Todos los pasos completados! Puede cerrar esta lista.",
    "charity.onboarding.expand": "Expandir lista",
    "charity.onboarding.collapse": "Contraer lista",
    "charity.onboarding.dismiss": "Cerrar lista de incorporación",
    "charity.onboarding.check": "Marcar {{label}}",
    "charity.onboarding.uncheck": "Desmarcar {{label}}",
    "charity.onboarding.stepDone": "{{label}} (completado)",
    "charity.onboarding.stepAuto": "{{label}} (se completa automáticamente)",
    "charity.onboarding.goToOrganization": "Ir a Organización",
    "charity.onboarding.setupWallet": "Configurar billetera",
    "charity.onboarding.item.completeProfile.label":
      "Completar el perfil de la organización",
    "charity.onboarding.item.completeProfile.description":
      "Agregue el nombre, la descripción, la dirección y la información de contacto de su organización.",
    "charity.onboarding.item.uploadLogo.label":
      "Subir logotipo o imagen de banner",
    "charity.onboarding.item.uploadLogo.description":
      "Agregue un logotipo o banner para que los donantes reconozcan su organización benéfica.",
    "charity.onboarding.item.connectWallet.label":
      "Configurar la billetera receptora",
    "charity.onboarding.item.connectWallet.description":
      "Elija una Safe multifirma, una custodia institucional o una billetera de un solo firmante para recibir donaciones. Demuestre el control firmando un mensaje.",
    "charity.onboarding.item.bankDetails.label":
      "Configurar datos bancarios para la conversión a moneda fiduciaria",
    "charity.onboarding.item.bankDetails.description":
      "Configure la información bancaria si desea aceptar donaciones con tarjeta.",
    "charity.onboarding.item.acceptTerms.label":
      "Revisar y aceptar los términos de servicio",
    "charity.onboarding.item.acceptTerms.description":
      "Lea y confirme los términos y condiciones de Give Protocol para organizaciones benéficas.",
    "charity.verification.pendingTitle": "Solicitud en revisión",
    "charity.verification.pendingBody":
      "Nuestro equipo está revisando la solicitud de su organización benéfica. Normalmente tarda de 3 a 5 días hábiles. Le enviaremos un correo electrónico cuando se tome una decisión.",
    "charity.verification.rejectedTitle": "Solicitud no aprobada",
    "charity.verification.reason": "Motivo: {{notes}}",
    "charity.verification.rejectedDefault":
      "Su solicitud no fue aprobada en este momento.",
    "charity.verification.contactSupport": "Contactar con soporte",
    "charity.verification.suspendedTitle": "Cuenta suspendida",
    "charity.verification.suspendedDefault":
      "La cuenta de su organización benéfica ha sido suspendida.",
    "charity.verification.appealSuspension": "Apelar la suspensión",
    "charity.verification.verifiedTitle": "Organización benéfica verificada",
    "charity.verification.verifiedBody":
      "Su organización está verificada y los donantes ya pueden apoyar sus causas.",
    "charity.portal.receivingWallet": "Billetera receptora: {{address}}",
    "charity.portal.loadError":
      "No se pudieron cargar los datos de la organización benéfica. Inténtelo de nuevo.",

    // Timestamps (GIV-254)
    "timestamp.justNow": "Justo ahora",
    "timestamp.oneMinuteAgo": "Hace 1 minuto",
    "timestamp.minutesAgo": "Hace {{count}} minutos",

    // Common additions (GIV-256)
    "common.previous": "Anterior",
    "common.next": "Siguiente",
    "common.pageOfTotal": "Página {{page}} de {{total}}",
    "common.retry": "Reintentar",
    "common.processing": "Procesando...",
    "common.saving": "Guardando...",
    "common.donate": "Donar",
    "common.active": "Activo",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "Tipo de Donación",
    "portfolio.devNative": "DEV (Nativo)",
    "portfolio.testToken": "Token TEST",
    "portfolio.donationAmount": "Monto de Donación:",
    "portfolio.platformFee": "Comisión de Plataforma ({{percentage}}%):",
    "portfolio.toCharities": "Para Organizaciones:",
    "portfolio.eachCharityReceives": "Cada organización recibe:",
    "portfolio.donateToFund": "Donar a {{name}}",
    "portfolio.equalDistribution": "Distribución Equitativa",
    "portfolio.equalDistributionNote":
      "Su donación se dividirá equitativamente entre {{count}} organizaciones verificadas.",
    "portfolio.eachCharityPercentage":
      "Cada organización recibe el {{percentage}}% de las donaciones",
    "portfolio.verifiedCharities": "{{count}} Organizaciones Verificadas",
    "portfolio.donateToFundButton": "Donar al Fondo",
    "portfolio.noFundsAvailable": "No hay fondos de portafolio disponibles",
    "portfolio.checkBackLater":
      "Vuelva más tarde para nuevas oportunidades de financiamiento",
    "portfolio.amountLabel": "Monto ({{currency}})",
    "portfolio.invalidAmount": "Ingrese un monto válido",
    "portfolio.donationSuccess": "¡Donación exitosa!",
    "portfolio.donationFailed": "Error en la donación. Intente nuevamente.",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "Donación",
    "admin.activity.registration": "Registro",
    "admin.activity.verification": "Verificación",
    "admin.activity.volunteerHours": "Horas de Voluntariado",
    "admin.activity.default": "Actividad",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "Panel de Administración",
    "admin.dashboard.alerts": "Alertas",
    "admin.dashboard.alertsPending": "{{count}} pendientes",
    "admin.dashboard.alertsView": "Ver",
    "admin.dashboard.recentActivity": "Actividad Reciente",
    "admin.dashboard.noRecentActivity": "Sin actividad reciente.",
    "admin.dashboard.quickActions": "Acciones Rápidas",
    "admin.dashboard.errorTitle": "Error al Cargar el Panel de Administración",
    "admin.stats.last7d": "últimos 7d",
    "admin.stats.last30d": "últimos 30d",
    "admin.stats.totalDonors": "Donantes Totales",
    "admin.stats.newRegistrations": "nuevos registros",
    "admin.stats.charities": "Organizaciones",
    "admin.stats.pendingVerification": "verificación pendiente",
    "admin.stats.verifiedCharities": "Organizaciones Verificadas",
    "admin.stats.activeVolunteers": "Voluntarios Activos",
    "admin.stats.totalDonationVolume": "Volumen Total de Donaciones",
    "admin.stats.cryptoVolume": "Volumen Cripto",
    "admin.stats.fiatVolume": "Volumen Fiat",
    "admin.stats.donations": "donaciones",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "Ver Informes",
    "admin.actions.viewReportsDesc": "Generar análisis detallados",
    "admin.actions.manageCharities": "Gestionar Organizaciones",
    "admin.actions.manageCharitiesDesc": "Revisar y aprobar organizaciones",
    "admin.actions.systemSettings": "Configuración del Sistema",
    "admin.actions.systemSettingsDesc":
      "Configurar parámetros de la plataforma",
    "admin.actions.manageImpactMetrics": "Gestionar Métricas de Impacto",
    "admin.actions.manageImpactMetricsDesc":
      "Configurar datos de la calculadora de impacto",
    "admin.actions.donationMonitoring": "Monitoreo de Donaciones",
    "admin.actions.donationMonitoringDesc":
      "Monitorear, marcar e informar sobre donaciones",
    "admin.actions.contentModeration": "Moderación de Contenido",
    "admin.actions.contentModerationDesc":
      "Ocultar, marcar y revisar oportunidades y causas",
    "admin.actions.portfolioFunds": "Fondos de Portafolio",
    "admin.actions.portfolioFundsDesc":
      "Crear y gestionar portafolios de donación",
    "admin.actions.charityRequests": "Solicitudes de Organizaciones",
    "admin.actions.charityRequestsDesc":
      "Revisar solicitudes de donantes para organizaciones no registradas",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "Fondos de Portafolio",
    "admin.portfolio.subtitle":
      "Crear y gestionar portafolios de donación curados",
    "admin.portfolio.newFund": "Nuevo Fondo",
    "admin.portfolio.editFund": "Editar Fondo",
    "admin.portfolio.createNewFund": "Crear Nuevo Fondo",
    "admin.portfolio.fundName": "Nombre del Fondo",
    "admin.portfolio.fundNamePlaceholder": "ej., Fondo de Impacto Ambiental",
    "admin.portfolio.description": "Descripción",
    "admin.portfolio.descriptionPlaceholder":
      "Describa el propósito y enfoque de impacto del fondo...",
    "admin.portfolio.category": "Categoría",
    "admin.portfolio.selectCategory": "Seleccionar una categoría",
    "admin.portfolio.imageUrl": "URL de Imagen",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "Seleccionar Organizaciones ({{count}} seleccionadas)",
    "admin.portfolio.noCharitiesFound":
      "No se encontraron organizaciones verificadas",
    "admin.portfolio.saving": "Guardando...",
    "admin.portfolio.createFund": "Crear Fondo",
    "admin.portfolio.updateFund": "Actualizar Fondo",
    "admin.portfolio.noFundsYet": "Aún no hay fondos de portafolio",
    "admin.portfolio.noFundsMessage":
      "Cree su primer fondo para agrupar organizaciones para donaciones conjuntas",
    "admin.portfolio.charity": "organización",
    "admin.portfolio.charities": "organizaciones",
    "admin.portfolio.createdOn": "Creado el {{date}}",
    "admin.portfolio.statusActive": "activo",
    "admin.portfolio.statusPaused": "pausado",
    "admin.portfolio.statusArchived": "archivado",
    "admin.portfolio.errorLoad": "Error al cargar datos",
    "admin.portfolio.errorArchive": "Error al archivar el fondo",
    "admin.portfolio.fundArchived": "Fondo archivado",
    "admin.portfolio.fundUpdated": "Fondo actualizado",
    "admin.portfolio.fundCreated": "Fondo creado",
    "admin.portfolio.errorSave": "Error al guardar el fondo",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "Gestión de Organizaciones",
    "admin.charity.totalCount": "{{count}} en total",
    "admin.charity.allStatuses": "Todos los estados",
    "admin.charity.searchPlaceholder": "Buscar por nombre\u2026",
    "admin.charity.colName": "Nombre",
    "admin.charity.colEin": "ID fiscal",
    "admin.charity.taxIdDisplay": "ID fiscal {{value}}",
    "admin.charity.searchByNameEin": "Buscar por nombre o ID fiscal…",
    "admin.charity.colCategory": "Categoría",
    "admin.charity.colStatus": "Estado",
    "admin.charity.colSigner": "Contacto",
    "admin.charity.colJoined": "Registro",
    "admin.charity.colWallet": "Billetera",
    "admin.charity.colActions": "Acciones",
    "admin.charity.walletNotSet": "No configurada",
    "admin.charity.approve": "Aprobar",
    "admin.charity.reject": "Rechazar",
    "admin.charity.suspend": "Suspender",
    "admin.charity.reinstate": "Reinstalar",
    "admin.charity.statusPending": "Pendiente",
    "admin.charity.statusVerified": "Verificada",
    "admin.charity.statusApproved": "Aprobada",
    "admin.charity.statusRejected": "Rechazada",
    "admin.charity.statusSuspended": "Suspendida",
    "admin.charity.approveTitle": "Aprobar Organización",
    "admin.charity.rejectTitle": "Rechazar Organización",
    "admin.charity.suspendTitle": "Suspender Organización",
    "admin.charity.reinstateTitle": "Reinstalar Organización",
    "admin.charity.confirmAction": "Confirmar Acción",
    "admin.charity.reasonRequired": "Razón (requerida)",
    "admin.charity.reasonOptional": "Razón (opcional)",
    "admin.charity.saving": "Guardando\u2026",
    "admin.charity.confirm": "Confirmar",
    "admin.charity.noResults":
      "No se encontraron organizaciones que coincidan con sus filtros.",
    "admin.charity.unnamed": "Organización sin nombre",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "Solicitudes de Organizaciones",
    "admin.charityRequests.subtitle":
      "Solicitudes de donantes para organizaciones no registradas, agrupadas por organización. Las organizaciones de mayor interés deben priorizarse para contacto.",
    "admin.charityRequests.ein": "ID fiscal",
    "admin.charityRequests.requests": "Solicitudes",
    "admin.charityRequests.latestRequester": "Último Solicitante",
    "admin.charityRequests.latestRequest": "Última Solicitud",
    "admin.charityRequests.firstRequest": "Primera Solicitud",
    "admin.charityRequests.empty":
      "Aún no se han enviado solicitudes de organizaciones.",
    "admin.charityRequests.errorTitle":
      "Error al Cargar Solicitudes de Organizaciones",
    "admin.charityRequests.showing":
      "Mostrando {{shown}} de {{total}} organizaciones únicas.",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "Supervisión de Validación de Voluntariado",
    "admin.validation.totalCount": "{{count}} solicitudes en total",
    "admin.validation.pipelineStats": "Estadísticas del Pipeline",
    "admin.validation.noStats": "No hay estadísticas disponibles.",
    "admin.validation.pending": "Pendiente",
    "admin.validation.approved": "Aprobado",
    "admin.validation.rejected": "Rechazado",
    "admin.validation.expired": "Expirado",
    "admin.validation.avgResponseTime": "Tiempo promedio de respuesta:",
    "admin.validation.expirationRate": "Tasa de expiración:",
    "admin.validation.rejectionRate": "Tasa de rechazo:",
    "admin.validation.searchPlaceholder": "Buscar voluntario, org\u2026",
    "admin.validation.requestsTab": "Solicitudes de Validación",
    "admin.validation.patternsTab": "Patrones Sospechosos",
    "admin.validation.colVolunteer": "Voluntario",
    "admin.validation.colOrganisation": "Organización",
    "admin.validation.colHours": "Horas",
    "admin.validation.colActivityDate": "Fecha de Actividad",
    "admin.validation.colHrsPerWeek": "Hrs/Semana",
    "admin.validation.colTotalRequests": "Total de Solicitudes",
    "admin.validation.override": "Anular",
    "admin.validation.noPatterns": "No se detectaron patrones sospechosos.",
    "admin.validation.noRequests":
      "No se encontraron solicitudes de validación.",
    "admin.validation.patternsDescription":
      "Voluntarios marcados por reportar más del umbral configurado de horas en una ventana móvil de 7 días. Estos patrones pueden indicar abuso del sistema de horas auto-reportadas.",
    "admin.validation.overrideTitle": "Anular Solicitud de Validación",
    "admin.validation.newStatus": "Nuevo Estado",
    "admin.validation.reasonRequired": "Razón (requerida)",
    "admin.validation.reasonPlaceholder":
      "Explique la razón para anular esta solicitud\u2026",
    "admin.validation.saving": "Guardando\u2026",
    "admin.validation.confirmOverride": "Confirmar Anulación",
    "admin.validation.allStatuses": "Todos los estados",
    "admin.validation.colStatus": "Estado",
    "admin.validation.colCreated": "Creado",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "Donaciones Transparentes",
    "home.hero.titleAccent": "Impacto Sostenible",
    "home.hero.description":
      "Filantropía radicalmente transparente para la era digital. Diseñada para generar impacto, respaldada por tecnología verificable. Cada contribución es rastreable desde el donante hasta el destino.",
    "home.hero.visionTitle": "Nuestra Visión",
    "home.hero.visionText":
      "Give Protocol está diseñando el futuro de la generosidad con alta integridad. Aprovechamos infraestructura tecnológica avanzada para cerrar la brecha entre el capital global y el impacto local. Al integrar soporte fluido de activos digitales con métodos tradicionales de donación, estamos creando ecosistemas de financiamiento resilientes que transforman donaciones únicas en motores perpetuos de apoyo para las causas más vitales del mundo.",
    "home.comingSoon": "Próximamente",
    "home.readDocs": "Leer Documentación",
    "home.features.sectionTitle":
      "Su Puerta de Entrada a la Filantropía Transparente",
    "home.features.sectionSubtitle":
      "Infraestructura multicadena para donaciones fluidas — cripto o fiat — con total transparencia",
    "home.features.highEfficiency.title": "Donaciones de Alta Eficiencia",
    "home.features.highEfficiency.description":
      "Contribuya directamente a organizaciones verificadas sin ambigüedad. Nuestro libro de contabilidad automatizado proporciona verificación en tiempo real, asegurando que su apoyo se destine exactamente donde más se necesita.",
    "home.features.equityFunds.title": "Fondos de Equidad Benéfica",
    "home.features.equityFunds.description":
      "Vaya más allá de las donaciones puntuales contribuyendo a fondos de equidad gestionados de forma inteligente. Utilizamos estrategias digitales sofisticadas y de bajo riesgo para convertir su capital en un flujo perpetuo de financiamiento, sosteniendo misiones benéficas por generaciones.",
    "home.features.impactFunds.title": "Fondos de Impacto",
    "home.features.impactFunds.description":
      "Agrupe recursos para causas específicas. Medio ambiente, educación, alivio de la pobreza: su donación amplificada a través de la acción colectiva.",
    "home.features.verifiedOrgs.title": "Organizaciones Verificadas",
    "home.features.verifiedOrgs.description":
      "Explore cualquier organización registrada o busque la insignia de verificación. Las organizaciones que optan por nuestro proceso de revisión obtienen verificación on-chain en la que los donantes pueden confiar.",
    "home.features.blockchainVerified.title": "Verificado en Blockchain",
    "home.features.blockchainVerified.description":
      "Los tokens vinculados al alma reconocen las contribuciones voluntarias. Habilidades, horas e impacto: todo registrado permanentemente on-chain.",
    "home.features.bridgingModes.title": "Conectando Formas de Donar",
    "home.features.bridgingModes.description":
      "Ya sea que done en USD o en activos digitales, nuestra arquitectura multirredes asegura que su contribución se mueva a la velocidad del mundo moderno.",
    "home.roles.title": "Diseñado para Todos los que Cambian el Mundo",
    "home.roles.donors.title": "Para Donantes",
    "home.roles.donors.item1": "Done en cripto o fiat — usted elige",
    "home.roles.donors.item2": "Participación en gobernanza",
    "home.roles.donors.item3": "Construcción de reputación on-chain",
    "home.roles.nonprofits.title": "Para Organizaciones Sin Fines de Lucro",
    "home.roles.nonprofits.item1": "Acceda a nuevos perfiles de donantes",
    "home.roles.nonprofits.item2": "Financiamiento sostenible mediante CEFs",
    "home.roles.nonprofits.item3": "Informes de transparencia mejorados",
    "home.roles.volunteers.title": "Para Voluntarios",
    "home.roles.volunteers.item1": "Registros de contribución verificables",
    "home.roles.volunteers.item2":
      "Credenciales de habilidades portátiles (SBTs)",
    "home.roles.volunteers.item3": "Insignias de logros y reconocimiento",
    "home.impact.title": "Fondos de Impacto Planificados",
    "home.impact.environmental.title": "Fondo de Impacto Ambiental",
    "home.impact.environmental.description":
      "Apoyando la reforestación, limpieza de océanos e iniciativas de energía renovable. Donaciones agrupadas dirigidas a organizaciones ambientales verificadas que generan impacto medible.",
    "home.impact.education.title": "Fondo de Oportunidades Educativas",
    "home.impact.education.description":
      "Proporcionando becas, herramientas de aprendizaje digital y capacitación docente. Financiamiento colectivo amplificado para apoyar iniciativas educativas en comunidades desatendidas.",
    "home.cta.title": "¿Listo para Transformar la Forma de Donar?",
    "home.cta.subtitle":
      "Sea de los primeros en experimentar la filantropía transparente impulsada por blockchain. Únase a nuestra comunidad que construye un mejor futuro para las donaciones benéficas.",
    "home.cta.explore": "Explorar Causas",
    "home.nav.features": "Características",
    "home.nav.impact": "Impacto",
    "home.nav.charities": "Organizaciones",
    "home.nav.volunteer": "Voluntariado",
    "home.footer.brand.tagline":
      "Transformando la filantropía a través de la transparencia blockchain y el financiamiento sostenible.",
    "home.footer.product.title": "Producto",
    "home.footer.product.impactFunds": "Fondos de Impacto",
    "home.footer.product.charities": "Para Organizaciones",
    "home.footer.product.volunteers": "Para Voluntarios",
    "home.footer.resources.title": "Recursos",
    "home.footer.resources.whitepaper": "Whitepaper (Próximamente)",
    "home.footer.resources.blog": "Blog (Próximamente)",
    "home.footer.resources.community": "Comunidad (Próximamente)",
    "home.footer.connect.title": "Conectar",
    "home.footer.connect.contact": "Contacto (Próximamente)",
    "home.footer.copyright":
      "Give Protocol. Multicadena por diseño. Impulsado por los voluntarios de Give Protocol.",
    "auth.signin.welcomeBack": "Bienvenido de nuevo",
    "auth.signin.subtitle": "Inicie sesión en su cuenta de Give Protocol",
    "auth.signin.emailPlaceholder": "Correo electrónico",
    "auth.signin.passwordPlaceholder": "Contraseña",
    "auth.signin.submitting": "Iniciando sesión…",
    "auth.signin.withPasskey": "Iniciar sesión con Passkey",
    "auth.signin.withGoogle": "Continuar con Google",
    "auth.signin.or": "o",
    "auth.signin.newToProtocol": "¿Es nuevo en Give Protocol?",
    "auth.signin.createAccount": "Crear una cuenta →",
    "auth.signin.forgotPasswordLink": "¿Olvidó su contraseña? →",
    "auth.signin.sslEncrypted": "Cifrado TLS",
    "auth.signin.modeToggleLabel": "Método de acceso",
    "auth.signin.terms": "Términos",
    "auth.signin.privacy": "Privacidad",
    "auth.panel.headline": "Donaciones inteligentes, impacto transparente.",
    "auth.panel.subheadline":
      "Una cuenta. Done con tarjeta o cripto. Rastree cada dólar on-chain.",
    "auth.panel.statusLabel": "Estado del Protocolo · Fase Génesis",
    "auth.panel.statusDesc":
      "Construyendo los cimientos de la donación transparente",
    "auth.panel.runsOn": "Funciona con",
    "auth.wallet.connect": "Conectar Billetera",
    "auth.wallet.connecting": "Conectando billetera…",
    "auth.wallet.signing": "Firmando mensaje…",
    "auth.wallet.verifying": "Verificando…",
    "auth.wallet.openingSession": "Abriendo sesión…",
    "auth.validation.emailRequired":
      "Ingrese su dirección de correo electrónico primero",
    "auth.validation.invalidEmail":
      "Ingrese una dirección de correo electrónico válida",
    "auth.validation.passwordTooShort":
      "La contraseña debe tener al menos 8 caracteres",
    "auth.validation.passwordMismatch": "Las contraseñas no coinciden",
    "auth.login.welcomeHeading": "Bienvenido a Give Protocol",
    "auth.login.signInOrConnect": "Iniciar Sesión o Conectar",
    "auth.login.skipToContent": "Ir al contenido de inicio de sesión",
    "auth.login.donorTitle": "Inicio de Sesión de Donante",
    "auth.login.donorSubtitle":
      "Inicie sesión para acceder a su panel de donaciones",
    "auth.login.charityTitle": "Portal de Organizaciones",
    "auth.login.charitySubtitle":
      "Administre el perfil y las donaciones de su organización",
    "auth.login.back": "← Volver",
    "auth.login.continueDonor": "Continuar como Donante",
    "auth.login.connecting": "Conectando…",
    "auth.login.connectWalletSignIn": "Conectar Billetera e Iniciar Sesión",
    "auth.login.newToPlatform": "¿Es nuevo en Give Protocol?",
    "auth.login.newDonorSignUp": "Registro de Nuevo Donante",
    "auth.login.manageNonprofit":
      "Administro una organización sin fines de lucro",
    "auth.login.nonprofitTrayTitle": "¿Es nuevo en Give Protocol?",
    "auth.login.createNonprofitAccount": "Crear Cuenta de Organización",
    "auth.login.registerOrg": "Registre su organización en Give Protocol",
    "auth.login.needHelp": "¿Necesita ayuda?",
    "auth.login.forgotUsernameBtn": "¿Olvidó su usuario?",
    "auth.login.forgotPasswordBtn": "¿Olvidó su contraseña?",
    "auth.donorLogin.mismatch":
      "Cuenta de Donante No Encontrada. Este correo está registrado como cuenta de organización. Utilice el inicio de sesión para organizaciones.",
    "auth.donorLogin.signingIn": "Iniciando sesión…",
    "auth.donorLogin.redirecting": "Redirigiendo en {{count}}...",
    "auth.donorReg.pleaseWait": "Espere por favor…",
    "auth.donorReg.signUpPasskey": "Registrarse con Passkey",
    "auth.donorReg.withGoogle": "Continuar con Google",
    "auth.donorReg.connectWallet": "Conectar Billetera",
    "auth.donorReg.orSetPassword": "O establezca una contraseña",
    "auth.donorReg.creating": "Creando Cuenta...",
    "auth.donorReg.createAccount": "Crear Cuenta de Donante",
    "auth.donorReg.privacyNotice": "Al crear una cuenta, acepta nuestros",
    "auth.donorReg.termsLink": "Términos de Servicio",
    "auth.donorReg.privacyAnd": "y reconoce nuestra",
    "auth.donorReg.privacyLink": "Política de Privacidad",
    "auth.charityLogin.mismatch":
      "Este correo está registrado como cuenta de donante. Inicie sesión en el portal de donantes.",
    "auth.charityLogin.signingIn": "Iniciando sesión...",
    "auth.charityLogin.or": "o",
    "auth.charityLogin.connecting": "Conectando...",
    "auth.charityLogin.connectWallet": "Conectar Billetera",
    "auth.forgot.resetPassword": "Restablecer Contraseña",
    "auth.forgot.forgotUsername": "Recuperar Usuario",
    "auth.forgot.passwordDesc":
      "Ingrese su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
    "auth.forgot.usernameDesc":
      "Ingrese su dirección de correo electrónico y le enviaremos su nombre de usuario.",
    "auth.forgot.passwordSuccess":
      "Se han enviado las instrucciones para restablecer su contraseña a su correo electrónico",
    "auth.forgot.usernameSuccess":
      "Se ha enviado un recordatorio de su nombre de usuario a su correo electrónico",
    "auth.forgot.checkEmail": "Revise su correo electrónico",
    "auth.forgot.backToSignIn": "Volver a Iniciar Sesión",
    "auth.forgot.emailPlaceholder":
      "Ingrese su dirección de correo electrónico",
    "auth.forgot.genericError": "Ocurrió un error. Intente nuevamente.",
    "auth.forgot.sending": "Enviando...",
    "auth.forgot.sendResetLink": "Enviar Enlace de Restablecimiento",
    "auth.forgot.sendUsername": "Enviar Usuario",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "Nombre de la Organización",
    "auth.orgSearch.searchPlaceholder": "Buscar por nombre de organización...",
    "auth.orgSearch.countryLabel": "País",
    "auth.orgSearch.allCountries": "Todos los Países",
    "auth.orgSearch.searchPrompt":
      "Busque en nuestra base de datos para encontrar y reclamar su organización.",
    "auth.orgSearch.noResults": "No se encontraron organizaciones.",
    "auth.orgSearch.loadMore": "Cargar más resultados",
    "auth.orgSearch.cantFind": "¿No encuentra su organización?",
    "auth.orgSearch.registerManually": "Registrar manualmente",
    "charity.claim.orgDetails": "Datos de la Organización (del Registro)",
    "charity.claim.orgNameLabel": "Nombre",
    "charity.claim.einLabel": "ID fiscal",
    "charity.claim.locationLabel": "Ubicación",
    "charity.claim.contactInfo": "Información de Contacto",
    "charity.claim.contactName": "Nombre de Contacto",
    "charity.claim.contactEmail": "Correo de Contacto",
    "charity.claim.accountSecurity": "Seguridad de la Cuenta",
    "charity.claim.password": "Contraseña",
    "charity.claim.confirmPassword": "Confirmar Contraseña",
    "charity.claim.backToSearch": "Volver a la búsqueda",
    "charity.claim.creating": "Creando Cuenta...",
    "charity.claim.submit": "Reclamar Organización",
    "charity.claim.validation.name":
      "El nombre debe tener entre 2 y 100 caracteres",
    "charity.claim.validation.email":
      "Ingrese una dirección de correo electrónico válida",
    "charity.claim.validation.password":
      "La contraseña debe tener al menos 8 caracteres",
    "charity.claim.validation.confirmPassword": "Las contraseñas no coinciden",
    "charity.claim.validation.fix": "Corrija los errores de validación",
    "charity.claim.useAsPublicEmail":
      "Usar mi correo como el correo de contacto público de la organización",
    "charity.claim.publicContactEmail":
      "Correo electrónico de contacto público de la organización",
    "charity.claim.privacyNotice":
      "Su correo y teléfono personal de firmante se utilizan solo para verificación y no son visibles para otros usuarios de la plataforma. El correo de contacto público se muestra en el perfil de su organización.",
    "charity.claim.secondContactTitle": "Segundo Contacto",
    "charity.claim.secondContactName": "Nombre del segundo contacto",
    "charity.claim.secondContactEmail": "Correo electrónico del segundo contacto",
    "charity.claim.secondContactHint":
      "Una persona diferente, notificada cuando cambian la billetera o los datos de pago de su organización.",
    "charity.claim.validation.secondEmailDistinct":
      "El correo del segundo contacto debe ser diferente del correo principal",
    "charity.claim.error.creation": "Error al crear la cuenta",
    "charity.claim.error.generic": "No se pudo crear la cuenta",
    "charity.vetting.orgDetails": "Datos de la Organización",
    "charity.vetting.orgName": "Nombre de la Organización",
    "charity.vetting.description": "Descripción",
    "charity.vetting.taxId": "ID Fiscal o de Registro",
    "charity.vetting.countryLabel": "País",
    "charity.vetting.selectCountry": "Seleccionar País",
    "charity.vetting.address": "Dirección",
    "charity.vetting.streetAddress": "Dirección",
    "charity.vetting.city": "Ciudad",
    "charity.vetting.state": "Estado/Provincia",
    "charity.vetting.postalCode": "Código Postal",
    "charity.vetting.contactInfo": "Información de Contacto",
    "charity.vetting.contactName": "Nombre de Contacto",
    "charity.vetting.contactEmail": "Correo de Contacto",
    "charity.vetting.accountSecurity": "Seguridad de la Cuenta",
    "charity.vetting.password": "Contraseña",
    "charity.vetting.confirmPassword": "Confirmar Contraseña",
    "charity.vetting.submitting": "Enviando Solicitud...",
    "charity.vetting.submit": "Enviar Solicitud de Organización",
    "charity.vetting.validation.orgName":
      "El nombre de la organización debe tener entre 2 y 100 caracteres",
    "charity.vetting.validation.contactName":
      "El nombre de contacto debe tener entre 2 y 100 caracteres",
    "charity.vetting.validation.email":
      "Ingrese una dirección de correo electrónico válida",
    "charity.vetting.validation.password":
      "La contraseña debe tener al menos 8 caracteres",
    "charity.vetting.validation.confirmPassword":
      "Las contraseñas no coinciden",
    "charity.vetting.validation.description": "La descripción es obligatoria",
    "charity.vetting.validation.category": "La categoría es obligatoria",
    "charity.vetting.validation.taxId": "El ID fiscal es obligatorio",
    "charity.vetting.validation.streetAddress": "La dirección es obligatoria",
    "charity.vetting.validation.city": "La ciudad es obligatoria",
    "charity.vetting.validation.country": "El país es obligatorio",
    "charity.vetting.validation.fix": "Corrija los errores de validación",
    "charity.vetting.error.generic": "No se pudo enviar la solicitud",
    "charity.vetting.privacyNotice":
      "Al enviar esta solicitud, acepta nuestros",
    "charity.vetting.termsLink": "Términos de Servicio",
    "charity.vetting.privacyAnd": "y reconoce nuestra",
    "charity.vetting.privacyLink": "Política de Privacidad",
    "common.email": "Correo electrónico",
    "common.password": "Contraseña",
    "common.confirmPassword": "Confirmar Contraseña",
    "footer.brand.tagline":
      "Eliminando barreras para la donación benéfica sostenible.",
    "footer.resources.title": "Recursos",
    "footer.resources.faq": "Preguntas Frecuentes",
    "footer.resources.about": "Acerca de Nosotros",
    "footer.legal.title": "Legal",
    "footer.legal.terms": "Términos de Servicio",
    "footer.legal.privacy": "Política de Privacidad",
    "footer.legal.cookiePreferences": "Preferencias de cookies",
    "consent.banner.ariaLabel": "Consentimiento de cookies",
    "consent.banner.body":
      "Utilizamos Google Analytics 4 (Google LLC, EE.\u00a0UU.) y Sentry (Functional Software, EE.\u00a0UU./UE) para comprender cómo se utiliza la aplicación y detectar errores. No se comparten direcciones de correo electrónico, direcciones de wallet ni nombres de donantes. Puede retirar su consentimiento en cualquier momento.",
    "consent.banner.privacyLink": "Política de privacidad",
    "consent.banner.acceptAll": "Aceptar todas",
    "consent.banner.decline": "Rechazar no esenciales",
    "consent.banner.customize": "Personalizar",
    "consent.modal.title": "Preferencias de cookies",
    "consent.modal.essentialTitle": "Esenciales",
    "consent.modal.essentialDesc":
      "Necesarias para las funciones principales del sitio, como la navegación y la autenticación. No se pueden desactivar.",
    "consent.modal.essentialAlwaysOn": "Cookies esenciales — siempre activas",
    "consent.modal.analyticsTitle":
      "Análisis (Google Analytics 4 · EE.\u00a0UU., Sentry · EE.\u00a0UU./UE)",
    "consent.modal.analyticsDesc":
      "Las cookies de análisis nos ayudan a comprender qué páginas se visitan y cómo los usuarios navegan por la aplicación. Utilizamos Google Analytics 4 \u2014 identificadores de sesión, URL de páginas, metadatos de dispositivo/navegador, ubicación aproximada a partir de IP anonimizada (Google LLC, EE.\u00a0UU.; SCCs + EU\u2013US Data Privacy Framework). Sentry \u2014 trazas de errores anonimizadas y metadatos del navegador para la supervisión de fiabilidad (Functional Software, UE/EE.\u00a0UU.; mecanismo de transferencia pendiente). No se comparten direcciones de correo electrónico, direcciones de wallet ni nombres de donantes con ningún procesador.",
    "consent.modal.analyticsOn": "Análisis y registro de errores — activado",
    "consent.modal.analyticsOff":
      "Análisis y registro de errores — desactivado",
    "consent.modal.cancel": "Cancelar",
    "consent.modal.save": "Guardar preferencias",
    "footer.connect.title": "Conectar",
    "footer.copyright": "Give Protocol. Todos los derechos reservados.",
    "nav.signIn": "Iniciar Sesión",
    "nav.signOut": "Cerrar Sesión",
    "nav.privacy": "Privacidad",
    "auth.signup.heading": "Cree su cuenta",
    "auth.signup.subtitle": "Únase al movimiento de donaciones transparentes",
    "auth.signup.displayName": "Nombre para mostrar",
    "auth.signup.emailPlaceholder": "Correo electrónico",
    "auth.signup.passwordPlaceholder": "Contraseña",
    "auth.signup.confirmPasswordPlaceholder": "Confirmar contraseña",
    "auth.signup.submit": "Crear Cuenta",
    "auth.signup.submitting": "Creando cuenta…",
    "auth.signup.withPasskey": "Registrarse con Passkey",
    "auth.signup.withGoogle": "Continuar con Google",
    "auth.signup.connectWallet": "Conectar Billetera",
    "auth.signup.orSetPassword": "O establezca una contraseña",
    "auth.signup.alreadyHaveAccount": "¿Ya tiene una cuenta?",
    "auth.signup.signInLink": "Iniciar sesión",
    "auth.signup.manageNonprofit":
      "¿Administra una organización sin fines de lucro?",
    "auth.signup.trustText": "Sus datos están protegidos por",
    "auth.signup.and": "y",
    "auth.signup.privacyPolicy": "Política de Privacidad",
    "auth.signup.panel.headline": "Donaciones que puede verificar.",
    "browse.hero.title": "Donaciones verificadas on-chain.",
    "browse.hero.subtitle":
      "Descubre causas verificadas, dona con tarjeta o activos digitales y ve el impacto tangible de tu tiempo y recursos.",
    "browse.stats.networks": "Redes compatibles",
    "browse.stats.sectors": "Sectores benéficos",
    "browse.stats.verifiedOrgs": "Organizaciones verificadas",
    "browse.stats.volunteerHours": "Horas de voluntariado",
    "browse.verified": "Verificada",
    "browse.donate": "Donar",
    "browse.viewProfile": "Ver perfil",
    "browse.filter.ariaLabel": "Filtrar organizaciones",
    "browse.filter.searchAria": "Buscar organizaciones",
    "browse.filter.locationAria": "Buscar ubicación",
    "browse.results.ariaLabel": "Resultados de organizaciones",
    "browse.tabs.charities": "Organizaciones",
    "browse.tabs.causes": "Causas",
    "browse.tabs.funds": "Fondos de Portafolio",
    "browse.tabs.ariaLabel": "Categorías de exploración",
    "browse.featured.heading": "Organizaciones destacadas",
    "browse.featured.ariaLabel": "Organizaciones destacadas",
    "browse.featured.nextAria": "Siguientes organizaciones destacadas",
    "browse.causes.heading": "Causas destacadas",
    "browse.causes.ariaLabel": "Causas destacadas",
    "browse.causes.badge": "Causa",
    "browse.causes.raised": "recaudado",
    "browse.causes.percentOf": "% de",
    "browse.causes.by": "por",
    "browse.causes.supportCta": "Apoyar Esta Causa",
    "browse.causes.giveCta": "Donar",
    "browse.causes.nextAria": "Siguientes causas destacadas",
    "browse.funds.heading": "Fondos de Portafolio",
    "browse.funds.ariaLabel": "Fondos de Portafolio",
    "browse.funds.badge": "Fondo de Portafolio",
    "browse.funds.charity": "organización",
    "browse.funds.charities": "organizaciones",
    "browse.funds.donateCta": "Donar al Fondo",
    "browse.funds.nextAria": "Siguientes fondos de portafolio",
    "portfolio.notFound.title": "Fondo de portafolio no encontrado",
    "portfolio.notFound.body":
      "El fondo de portafolio que buscas no existe o ya no está activo.",
    "portfolio.supportedOrgs": "Organizaciones apoyadas",
    "browse.charity.einLabel": "ID fiscal",
    "browse.charity.einDisplay": "ID fiscal: {{value}}",
    "browse.charity.nteeLabel": "Código de sector",
    "browse.charity.deductibilityLabel": "Deducibilidad",
    "browse.charity.onPlatform": "En la Plataforma",
    "browse.charity.loading": "Cargando…",
    "browse.charity.loadMore": "Cargar Más",
    "browse.filter.searchPlaceholder": "Buscar organizaciones benéficas...",
    "browse.filter.locationPlaceholder": "Ciudad, estado o país...",
    "browse.whyGiveProtocol.heading": "¿Por qué Give Protocol?",
    "browse.whyGiveProtocol.verified.title": "Organizaciones verificadas",
    "browse.whyGiveProtocol.verified.description":
      "Cada organización se verifica contra registros públicos antes de aparecer en la plataforma.",
    "browse.whyGiveProtocol.onchain.title": "Transparencia en cadena",
    "browse.whyGiveProtocol.onchain.description":
      "Las donaciones se registran en la blockchain para que puedas rastrear tu impacto desde la billetera hasta la causa.",
    "browse.whyGiveProtocol.volunteer.title": "Dona tiempo, no solo dinero",
    "browse.whyGiveProtocol.volunteer.description":
      "Las horas de voluntariado son verificadas por las organizaciones y cuentan para tu reputación en el protocolo.",
    "browse.news.heading": "Noticias de la Plataforma",
    "admin.news.deleteConfirmBody": "«{{title}}» se eliminará de forma permanente. Esta acción no se puede deshacer.",
    "admin.news.deleteConfirmTitle": "¿Eliminar la noticia?",
    "admin.news.saveFailed": "No se pudieron guardar los cambios. Inténtelo de nuevo.",
    "admin.news.urlHelp": "Opcional. Déjelo en blanco para mostrar la noticia sin enlace.",
    "admin.news.urlInvalid": "Introduzca una dirección completa https:// o una ruta que empiece por /.",
    "browse.carousel.error": "No pudimos cargar esta sección. Actualice la página e inténtelo de nuevo.",
    "browse.carousel.goToPage": "Ir a la página {{page}}",
    "browse.carousel.pageLabel": "Página {{current}} de {{total}}",
    "browse.carousel.pause": "Pausar la rotación automática",
    "browse.carousel.play": "Reanudar la rotación automática",
    "browse.causes.empty": "Aún no hay causas disponibles. ¡Vuelva pronto!",
    "browse.causes.prevAria": "Causas destacadas anteriores",
    "browse.causes.searchPlaceholder": "Buscar causas...",
    "browse.causes.subheading": "Apoye proyectos concretos que generan un impacto real.",
    "browse.charity.registryIdDisplay": "ID de registro: {{value}}",
    "browse.featured.empty": "Aún no hay organizaciones destacadas. Use la búsqueda de arriba para encontrar una organización benéfica.",
    "browse.featured.prevAria": "Organizaciones destacadas anteriores",
    "browse.featured.subheading": "Un vistazo rotativo a organizaciones benéficas verificadas en Give Protocol.",
    "browse.filter.addLocation": "Añadir ubicación",
    "browse.filter.impactNotice": "El filtrado por ubicación de impacto aún no está disponible, por lo que los resultados no se limitan por ubicación de impacto.",
    "browse.filter.locationHint": "Pulse Intro o elija Añadir para aplicar una ubicación.",
    "browse.filter.minChars": "Escriba al menos 2 caracteres para buscar.",
    "browse.funds.empty": "Aún no hay fondos de portafolio disponibles. ¡Vuelva pronto!",
    "browse.funds.prevAria": "Fondos de portafolio anteriores",
    "browse.funds.searchPlaceholder": "Buscar fondos de portafolio...",
    "browse.funds.subheading": "Portafolios de donación seleccionados que distribuyen las donaciones entre organizaciones benéficas verificadas.",
    "browse.registry.badge": "Registrada en {{registry}}",
    "browse.results.empty": "Ninguna organización coincide con esa búsqueda. Pruebe con otra palabra clave o añada un filtro de ubicación.",
    "browse.results.error": "No pudimos realizar esa búsqueda. Inténtelo de nuevo.",
    "browse.search.noMatches": "Nada coincide con «{{query}}».",
    "browse.category.A": "Arte y cultura",
    "browse.category.B": "Educación",
    "browse.category.C": "Medio ambiente",
    "browse.category.D": "Bienestar animal",
    "browse.category.E": "Salud",
    "browse.category.F": "Salud mental",
    "browse.category.G": "Investigación médica",
    "browse.category.H": "Investigación biomédica",
    "browse.category.I": "Delito y justicia",
    "browse.category.J": "Empleo",
    "browse.category.K": "Alimentación y nutrición",
    "browse.category.L": "Vivienda",
    "browse.category.M": "Seguridad pública",
    "browse.category.N": "Recreación",
    "browse.category.O": "Desarrollo juvenil",
    "browse.category.P": "Servicios humanos",
    "browse.category.Q": "Internacional",
    "browse.category.R": "Derechos civiles",
    "browse.category.S": "Desarrollo comunitario",
    "browse.category.T": "Filantropía",
    "browse.category.U": "Ciencia y tecnología",
    "browse.category.V": "Ciencias sociales",
    "browse.category.W": "Políticas públicas",
    "browse.category.X": "Religión",
    "browse.category.Y": "Beneficio mutuo",
    "browse.category.default": "Organización sin fines de lucro",
    "cause.causes": "Causas",
    "cause.createNew": "Crear Nueva",
    "cause.noCausesTitle": "Aún no hay causas",
    "cause.name": "Nombre",
    "cause.description": "Descripción",
    "cause.category": "Categoría",
    "cause.targetAmount": "Monto Objetivo",
    "cause.headerImage": "Imagen de Encabezado",
    "cause.impact": "Impacto",
    "cause.impactHelp": "Describa el impacto esperado de esta causa.",
    "cause.location": "Ubicación",
    "cause.timeline": "Cronograma",
    "cause.partners": "Socios",
    "cause.limitReached": "Límite de causas alcanzado",
    "impact.statistics": "Estadísticas de Impacto",
    "impact.statLabel": "Etiqueta",
    "impact.statValue": "Valor",
    "impact.missionStatement": "Declaración de Misión",
    "impact.missionPlaceholder": "Nuestra misión es...",
    "impact.highlights": "Logros Destacados",
    "impact.highlight": "Logro destacado",
    "impact.addHighlight": "Agregar Logro",
    "impact.profile": "Perfil de Impacto",
    "impact.loadError": "Error al cargar el perfil de impacto",
    "impact.saveError": "Error al guardar el perfil de impacto",
    "impact.saveSuccess": "Perfil de impacto guardado exitosamente",
    "organization.yearFounded": "Año de Fundación",
    "organization.address": "Dirección",
    "organization.street": "Dirección",
    "organization.city": "Ciudad",
    "organization.stateProvince": "Estado/Provincia",
    "organization.postalCode": "Código Postal",
    "organization.country": "País",
    "organization.contactInfo": "Información de Contacto",
    "organization.phone": "Teléfono",
    "organization.email": "Correo electrónico",
    "organization.website": "Sitio web",
    "organization.socialMedia": "Redes Sociales",
    "organization.publicFeed": "Feed Público",
    "organization.communityMedia": "Comunidad y Medios",
    "organization.profile": "Perfil de la Organización",
    "organization.loadError": "Error al cargar el perfil de la organización",
    "organization.saveError": "Error al guardar el perfil de la organización",
    "common.remove": "Eliminar",
    "common.saveChanges": "Guardar Cambios",
    "dashboard.thisMonth": "Este mes",
    "dashboard.verified": "Voluntarios verificados",
    "dashboard.hoursLogged": "Horas registradas",
    "dashboard.endorsements": "Avales",
    "dashboard.organizationsHelped": "Organizaciones Ayudadas",
    "dashboard.yourOrganizationsHelped": "Sus Organizaciones Ayudadas",
    "transactions.createCampaign": "Cree su primera campaña",
    "contributions.emptyTitle": "Su camino de donaciones comienza aquí",
    "contributions.browseCharities": "Explorar organizaciones",
    "charity.profile.verified501c3":
      "Organización sin fines de lucro verificada",
    "charity.profile.verified501c3Tooltip":
      "Organización 501(c)(3) registrada — las donaciones pueden ser deducibles de impuestos en los Estados Unidos",
    "charity.profile.statusClaimed": "Reclamada",
    "charity.profile.statusUnclaimed":
      "No reclamada — solo datos del registro público",
    "charity.profile.statusIrsVerified":
      "Organización sin fines de lucro verificada por el IRS",
    "charity.profile.requestWidget.unclaimedBody":
      "Esta organización todavía no ha reclamado su perfil en Give Protocol. Las donaciones estarán disponibles cuando la organización reclame su perfil y complete la configuración de su billetera.",
    "charity.profile.rowEin": "ID fiscal",
    "charity.profile.rowName": "Nombre",
    "charity.profile.rowLocation": "Ubicación",
    "charity.profile.rowRulingYear": "Año de registro",
    "charity.profile.rowNteeCode": "Código de sector",
    "charity.profile.rowDeductibility": "Deducibilidad",
    "charity.profile.rowAffiliation": "Afiliación",
    "charity.profile.rowClassification": "Clasificación",
    "charity.profile.rowFoundation": "Tipo de fundación",
    "charity.profile.rowActivityCodes": "Códigos de actividad",
    "charity.profile.rowOrgType": "Tipo de organización",
    "charity.profile.rowSubsection": "Subsección",
    "charity.profile.rowStatus": "Estado",
    "charity.profile.registryRecord": "Registro Público",
    "charity.profile.einDisplay": "ID fiscal",
    "charity.profile.charityNotFoundByTaxId":
      "No pudimos encontrar una organización benéfica con este ID fiscal.",
    "charity.profile.registeredNonprofit":
      "Organización sin fines de lucro registrada",
    "charity.profile.registeredYear": "Registrada en {{year}}",
    "charity.profile.shareAria": "Compartir",
    "charity.profile.copied": "¡Copiado!",
    "charity.profile.about": "Acerca de",
    "charity.profile.claimProfile": "Reclamar este perfil",
    "charity.profile.noDescription": "No hay descripción disponible.",
    "charity.profile.toAddOne": "para agregar una.",
    "charity.profile.contact": "Contacto",
    "charity.profile.donate.support": "Apoyar",
    "charity.profile.donate.walletUnset":
      "Esta organización aún no ha configurado una billetera oficial.",
    "charity.profile.donate.walletPending":
      "Esta organización está configurando su billetera — las donaciones no están disponibles temporalmente.",
    "charity.profile.donate.walletLegacy":
      "Esta organización utiliza una dirección de billetera heredada.",
    "charity.profile.donate.feeNote":
      "0% de tarifa de plataforma en donaciones directas. Se aplican tarifas de red.",
    "charity.profile.donate.jurisdictionUnavailable":
      "Las donaciones a organizaciones benéficas fuera de los Estados Unidos aún no están disponibles en Give Protocol.",
    "portfolio.title": "Fondos de Portafolio",
    "settings.displayPreferences": "Preferencias de visualización",
    "settings.theme": "Tema",
    "settings.light": "Claro",
    "settings.dark": "Oscuro",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "Entiendo que mi registro de donación me vincula con {{charity}}. En la medida en que esto pueda indicar una afiliación religiosa, política o filosófica, consiento expresamente que Give Protocol procese este registro para completar y administrar mi donación.",
    "donation.art9Consent.label": "Consentimiento de datos de donación",
    "donation.art9Consent.required":
      "Debe dar su consentimiento al procesamiento de datos de donación para continuar.",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "Como medida técnica conforme al artículo 32 del RGPD, registramos y supervisamos el acceso administrativo a los datos personales —incluyendo la acción realizada y el momento en que ocurrió— para detectar accesos no autorizados, demostrar responsabilidad proactiva y reconstruir los hechos en el improbable caso de una violación de datos personales (artículo 34). Los datos personales de los donantes no se duplican en estos registros de acceso administrativo. Los registros de acceso administrativo son distintos de los registros de autenticación y seguridad descritos en el §7.1; su período de retención está regulado por nuestro Registro de Actividades de Tratamiento interno.",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "Filtrar por acción",
    "admin.auditTrail.allActions": "Todas las acciones",
    "admin.auditTrail.action.charityStatusChange":
      "Cambio de estado de organización",
    "admin.auditTrail.action.userStatusChange": "Cambio de estado de usuario",
    "admin.auditTrail.action.donationFlag": "Marca de donación",
    "admin.auditTrail.action.donationFlagResolve":
      "Resolución de marca de donación",
    "admin.auditTrail.action.validationOverride": "Anulación de validación",
    "admin.auditTrail.action.configChange": "Cambio de configuración",
    "admin.auditTrail.action.verificationApprove": "Aprobación de verificación",
    "admin.auditTrail.action.verificationReject": "Rechazo de verificación",
    "admin.auditTrail.action.charitySuspend": "Suspensión de organización",
    "admin.auditTrail.action.charityReinstate": "Reinstalación de organización",
    "admin.auditTrail.action.userSuspend": "Suspensión de usuario",
    "admin.auditTrail.action.userReinstate": "Reinstalación de usuario",
    "admin.auditTrail.action.userBan": "Prohibición de usuario",
    "admin.auditTrail.action.viewPii": "Ver PII",
    "admin.auditTrail.action.viewPiiList": "Ver lista de PII",
    "admin.auditTrail.viewedEntity":
      "El administrador {{adminId}} vio {{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "El administrador {{adminId}} vio la lista de {{entityType}} (página {{page}}, filtros: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "El administrador {{adminId}} vio la lista de {{entityType}} (página {{page}})",
    "admin.actions.platformNews": "Novedades de la Plataforma",
    "admin.actions.platformNewsDesc":
      "Gestionar las novedades mostradas en la página de exploración",
    "admin.news.activate": "Activar {{title}}",
    "admin.news.activated": "Novedad publicada",
    "admin.news.activeLabel": "Publicada (visible al público)",
    "admin.news.categoryLabel": "Categoría",
    "admin.news.contentLabel": "Contenido / Extracto",
    "admin.news.contentPlaceholder": "Breve descripción de la novedad...",
    "admin.news.createNews": "Crear Novedad",
    "admin.news.createNewsBtn": "Crear Novedad",
    "admin.news.created": "Novedad creada",
    "admin.news.dateLabel": "Fecha de Publicación",
    "admin.news.deactivate": "Desactivar {{title}}",
    "admin.news.deactivated": "Novedad ocultada",
    "admin.news.deleteItem": "Eliminar {{title}}",
    "admin.news.deleted": "Novedad eliminada",
    "admin.news.editItem": "Editar {{title}}",
    "admin.news.editNews": "Editar Novedad",
    "admin.news.imageLabel": "URL de la imagen (opcional)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "Inactiva",
    "admin.news.newItem": "Nuevo Elemento",
    "admin.news.noItemsMessage":
      "Cree su primera novedad para compartir actualizaciones con su comunidad",
    "admin.news.noItemsYet": "Aún no hay novedades",
    "admin.news.publishedOn": "Publicada el {{date}}",
    "admin.news.saving": "Guardando...",
    "admin.news.subtitle":
      "Gestione las novedades mostradas en la página pública de exploración",
    "admin.news.title": "Novedades de la Plataforma",
    "admin.news.titleLabel": "Título",
    "admin.news.titlePlaceholder": "p. ej. Informe trimestral de impacto",
    "admin.news.updateNews": "Actualizar Novedad",
    "admin.news.updated": "Novedad actualizada",
    "admin.news.urlLabel": "URL del Enlace",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "Custodiada en {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "Las donaciones se envían a una billetera custodiada por un custodio institucional calificado.",
    "charity.walletBadge.safeLabel":
      "Tesorería multifirma · {{threshold}} de {{count}} firmantes",
    "charity.walletBadge.safeTooltip":
      "Las donaciones se envían a una billetera de firma múltiple que requiere varias aprobaciones antes de poder mover los fondos.",
    "wallet.eoa.chain": "Red",
    "wallet.eoa.checkAuthorized":
      "Estoy autorizado por mi organización para designar esta billetera como dirección receptora de donaciones benéficas.",
    "wallet.eoa.checkRisk":
      "Entiendo que una billetera de un solo firmante conlleva un riesgo mayor que una multifirma, y que la pérdida de la clave privada implica la pérdida permanente de los fondos.",
    "wallet.eoa.confirmSubtitle":
      "Confirme lo siguiente antes de registrar esta billetera.",
    "wallet.eoa.confirmTitle": "Confirmación final",
    "wallet.eoa.connectFirst": "Conecte primero su billetera.",
    "wallet.eoa.connectWallet": "Conectar billetera",
    "wallet.eoa.missingSignature":
      "Falta la firma. Vuelva atrás y firme de nuevo.",
    "wallet.eoa.proceedAnyway": "Entiendo, continuar",
    "wallet.eoa.register": "Registrar billetera",
    "wallet.eoa.registering": "Registrando...",
    "wallet.eoa.rejected": "La solicitud de firma fue rechazada.",
    "wallet.eoa.riskParagraph1":
      "Una billetera de un solo firmante (EOA) está controlada por una única clave privada. Si esa clave se pierde, es robada o queda comprometida, todos los fondos enviados a esta billetera son irrecuperables de forma permanente.",
    "wallet.eoa.riskParagraph2":
      "Para fondos organizacionales, recomendamos encarecidamente usar en su lugar una billetera multifirma Safe. Las billeteras multifirma requieren varias aprobaciones para cada transacción, protegiendo contra puntos únicos de falla.",
    "wallet.eoa.riskParagraph3":
      "Al continuar, usted reconoce que Give Protocol no es responsable de ninguna pérdida de fondos debido al compromiso, pérdida o mala gestión de la clave privada.",
    "wallet.eoa.riskTitle":
      "Billetera de un solo firmante: riesgos importantes",
    "wallet.eoa.signError": "No se pudo firmar el mensaje. Inténtelo de nuevo.",
    "wallet.eoa.signMessage": "Firmar mensaje de verificación",
    "wallet.eoa.signSubtitle":
      "Conecte su billetera y firme un mensaje para demostrar que controla esta dirección.",
    "wallet.eoa.signTitle": "Conectar y firmar",
    "wallet.eoa.useMultisig": "Usar una multifirma en su lugar",
    "wallet.eoa.walletConnection": "Billetera",
    "wallet.eoa.walletToRegister": "Billetera a registrar",
    "wallet.institutional.address": "Dirección de la billetera",
    "wallet.institutional.attestation": "Documento de certificación",
    "wallet.institutional.attestationHelp":
      "Suba un PDF, JPEG o PNG (máx. 10MB) que demuestre su relación de custodia.",
    "wallet.institutional.backToWallets": "Volver a las billeteras",
    "wallet.institutional.chain": "Red",
    "wallet.institutional.chooseFile": "Elegir archivo o arrastrar y soltar",
    "wallet.institutional.custodian": "Custodio",
    "wallet.institutional.fileTooLarge": "El archivo debe ser menor de 10MB.",
    "wallet.institutional.invalidAddress":
      "Introduzca una dirección de Ethereum válida (0x...)",
    "wallet.institutional.invalidFileType": "Suba un archivo PDF, JPEG o PNG.",
    "wallet.institutional.removeFile": "Eliminar archivo",
    "wallet.institutional.selectCustodian": "Seleccione un custodio.",
    "wallet.institutional.selectCustodianOption": "Seleccionar custodio...",
    "wallet.institutional.submit": "Enviar para revisión",
    "wallet.institutional.submittedDesc":
      "Su registro de billetera institucional está en revisión. Recibirá un correo electrónico dentro de 3 días hábiles.",
    "wallet.institutional.submittedTitle": "Billetera enviada para revisión",
    "wallet.institutional.submitting": "Enviando...",
    "wallet.institutional.subtitle":
      "Proporcione los datos de su billetera gestionada por un custodio y suba un documento de certificación para su verificación.",
    "wallet.institutional.title":
      "Registrar una billetera de custodia institucional",
    "wallet.institutional.uploadFile": "Subir archivo de certificación",
    "wallet.institutional.uploadRequired":
      "Suba un documento de certificación.",
    "wallet.safe.address": "Dirección Safe",
    "wallet.safe.chain": "Red",
    "wallet.safe.connectFirst": "Conecte primero su billetera firmante.",
    "wallet.safe.connectSigner": "Conectar billetera firmante",
    "wallet.safe.createNew": "Crear una nueva Safe",
    "wallet.safe.createNewDesc":
      "Abre app.safe.global donde puede crear una nueva multifirma. Vuelva aquí una vez que esté desplegada.",
    "wallet.safe.haveOne": "Ya tengo una Safe",
    "wallet.safe.haveOneDesc":
      "Introduzca la dirección de su Safe y verifique el control firmando un mensaje desde una billetera firmante.",
    "wallet.safe.invalidAddress":
      "Introduzca una dirección de Ethereum válida (0x...)",
    "wallet.safe.rejected": "La solicitud de firma fue rechazada.",
    "wallet.safe.signError":
      "No se pudo firmar el mensaje de verificación. Inténtelo de nuevo.",
    "wallet.safe.signVerify": "Firmar para verificar",
    "wallet.safe.signerWallet": "Billetera firmante",
    "wallet.safe.subtitle":
      "Una Safe requiere que varios firmantes aprueben cada transacción, proporcionando el mayor nivel de seguridad para los fondos de su organización.",
    "wallet.safe.title": "Configurar una billetera multifirma Safe",
    "wallet.safe.verifyTitle": "Verificar propiedad de la Safe",
    "wallet.safe.verifying": "Verificando...",
    "wallet.setup.addAnother": "Añadir otra",
    "wallet.setup.custodian": "Custodio",
    "wallet.setup.deleteFailed": "Error al eliminar la billetera",
    "wallet.setup.eoaDesc":
      "Una billetera estándar controlada por una única clave privada. La más simple, pero la menos segura para uso organizacional.",
    "wallet.setup.eoaTitle": "Un Solo Firmante (EOA)",
    "wallet.setup.institutionalDesc":
      "Gestionada por un custodio calificado (Fireblocks, Anchorage, etc.). Requiere documento de certificación.",
    "wallet.setup.institutionalTitle": "Custodia Institucional",
    "wallet.setup.makePrimary": "Marcar como principal",
    "wallet.setup.primary": "Principal",
    "wallet.setup.primaryFailed": "Error al actualizar la billetera principal",
    "wallet.setup.primaryUpdated": "Billetera principal actualizada",
    "wallet.setup.recommended": "Recomendado",
    "wallet.setup.remove": "Eliminar billetera",
    "wallet.setup.safeDesc":
      "Se requieren varios firmantes para cada transacción. La máxima seguridad para fondos organizacionales.",
    "wallet.setup.safeSigners": "Firmantes",
    "wallet.setup.safeTitle": "Safe Multifirma",
    "wallet.setup.subtitle":
      "Elija cómo recibirá su organización las donaciones en criptomonedas. Recomendamos una billetera multifirma para máxima seguridad.",
    "wallet.setup.title": "Configure su billetera receptora",
    "wallet.setup.viewExplorer": "Ver en el explorador de bloques",
    "wallet.setup.walletAdded": "Billetera registrada correctamente",
    "wallet.setup.walletDeleted": "Billetera eliminada",
    "wallet.setup.walletsTitle": "Billeteras receptoras",
    "admin.nav.dashboard": "Panel",
    "admin.nav.reports": "Informes y Análisis",
    "admin.nav.charities": "Organizaciones",
    "admin.nav.donations": "Donaciones",
    "admin.nav.impactMetrics": "Métricas de Impacto",
    "admin.nav.portfolioFunds": "Fondos de Portafolio",
    "admin.nav.contentModeration": "Moderación de Contenido",
    "admin.nav.settings": "Configuración del Sistema",
    "admin.nav.overview": "Resumen",
    "admin.nav.operations": "Operaciones",
    "admin.nav.consoleLabel": "Consola de Administración",
    "admin.shell.searchPlaceholder":
      "Buscar donantes, organizaciones, hash de tx…",
    "admin.shell.searchLabel": "Buscar en la consola de administración",
    "admin.shell.notifications": "Notificaciones",
    "admin.shell.adminLabel": "admin",
    "admin.shell.superAdmin": "Super Administrador",
    "admin.shell.signOut": "Cerrar sesión",
    "admin.shell.backToPublicSite": "Volver al sitio público",
    "admin.shell.homeLink": "Inicio de Give Protocol",
    "admin.dashboard.severityHigh": "Alta Prioridad",
    "admin.dashboard.severityMedium": "Requiere Atención",
    "admin.dashboard.severityLow": "Para Revisión",
    "admin.dashboard.alertOldest": "Solicitud más antigua enviada",
    "admin.dashboard.alertReviewHint":
      "revisión para mantener el proceso de incorporación en marcha",
    "admin.dashboard.reviewQueue": "Cola de revisión",
    "admin.dashboard.kpiDonorsSub": "{{count}} nuevos en los últimos 30 días",
    "admin.dashboard.kpiPending": "{{count}} pendientes",
    "admin.dashboard.awaitingVerification": "Pendiente de verificación",
    "admin.dashboard.kpiVerifiedSub": "de {{total}} aprobadas en total",
    "admin.dashboard.kpiVolunteersActive": "Inscripciones activas",
    "admin.dashboard.kpiVolunteersSub": "Sin inscripciones activas",
    "admin.dashboard.donationVolume": "Volumen de Donaciones",
    "admin.dashboard.donationVolumeSub": "{{range}} · cripto y fiat combinados",
    "admin.dashboard.range30d": "Últimos 30 días",
    "admin.dashboard.range90d": "Últimos 90 días",
    "admin.dashboard.rangeYtd": "Año hasta la fecha",
    "admin.dashboard.volumeEmptyTitle": "Aún no hay donaciones registradas",
    "admin.dashboard.volumeEmptySub":
      "El volumen se graficará aquí una vez que se liquide el primer donativo",
    "admin.dashboard.totalVolume": "Volumen total",
    "admin.dashboard.crypto": "Cripto",
    "admin.dashboard.fiat": "Fiat",
    "admin.dashboard.activitySubtitle":
      "Eventos de la plataforma a medida que ocurren",
    "admin.dashboard.viewAllActivity": "Ver toda la actividad",
    "admin.dashboard.viewAllDonations": "Ver todas las donaciones",
    "admin.charity.tabAll": "Todas",
    "admin.charity.review": "Revisar",
    "admin.charity.colOrganization": "Organización",
    "admin.charity.colRaised": "Recaudado",
    "admin.charity.colSubmitted": "Enviado",
    "admin.charity.searchAria": "Buscar organizaciones",
    "admin.charity.reviewTitle": "Revisar {{name}}",
    "admin.charity.submittedRelative": "Enviado {{when}}",
    "admin.charity.contactEmail": "Correo electrónico",
    "admin.charity.contactPhone": "Teléfono",
    "admin.charity.raisedUnavailable": "No hay total de donaciones disponible",
    "admin.error.title": "Error al Cargar Datos",
    "admin.error.recentActivity": "Error al Cargar Actividad Reciente",
    "admin.error.alerts": "Error al Cargar Alertas",
    "admin.error.donationVolume": "Error al Cargar el Volumen de Donaciones",
    "donation.gas.estimating": "Estimando tarifa de red…",
    "donation.gas.label": "Tarifa de red est.",
    "donation.gas.highGasWarning":
      "Alerta de tarifa alta: la tarifa estimada es {{usd}}, que representa {{pct}} de su donación.",
    "donation.gas.highGasSuggestion":
      "Considere una donación mayor o cambiar a una cadena con tarifas más bajas.",
    "donation.gas.l2Hint": "Para tarifas más bajas, pruebe {{chains}}.",
  },
};
